import { Link } from "react-router-dom";
import { Instagram } from "lucide-react";

const Footer = () => (
  <footer data-testid="footer" className="bg-[#1C1417] pt-20 sm:pt-28 pb-10 overflow-hidden">
    <div className="max-w-7xl mx-auto px-5 sm:px-8">
      <p className="font-serif font-light text-[#FAF7F5] leading-none tracking-tight text-[10vw] sm:text-8xl lg:text-9xl whitespace-nowrap">
        SKINFILL <span className="italic text-[#E893AE]">BACIO</span>
        <sup className="text-[3vw] sm:text-2xl">®</sup>
      </p>
      <p className="font-mono text-[10px] sm:text-xs uppercase tracking-[0.35em] text-[#D84A75] mt-4">
        The Lip Booster
      </p>

      <div className="mt-14 grid sm:grid-cols-3 gap-10 border-t border-white/10 pt-12">
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4EBE6]/50">Official distributor</p>
          <p className="font-serif text-xl text-[#FAF7F5] mt-4">DERMALIS</p>
          <p className="text-xs text-[#F4EBE6]/55 font-light mt-1.5">Australia &amp; New Zealand</p>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4EBE6]/50">Professional enquiries</p>
          <a data-testid="footer-email-info" href="mailto:info@dermalis.com.au" className="block text-sm text-[#F4EBE6]/80 hover:text-[#E893AE] transition-colors mt-4">
            info@dermalis.com.au
          </a>
        </div>
        <div>
          <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#F4EBE6]/50">Follow</p>
          <div className="flex gap-3 mt-4">
            <a
              data-testid="footer-social-instagram"
              href={process.env.REACT_APP_INSTAGRAM_URL}
              target="_blank"
              rel="noopener noreferrer"
              aria-label="Skinfill Bacio on Instagram — @skinfillbacio.anz"
              className="w-10 h-10 rounded-full border border-white/15 flex items-center justify-center text-[#F4EBE6]/70 hover:text-[#E893AE] hover:border-[#E893AE]/50 transition-colors"
            >
              <Instagram size={16} />
            </a>
          </div>
          <p className="mt-3 font-mono text-[10px] tracking-[0.15em] text-[#F4EBE6]/40">@skinfillbacio.anz</p>
          <div className="flex flex-wrap gap-x-5 gap-y-2 mt-6">
            <Link
              data-testid="footer-link-privacy"
              to="/privacy"
              className="text-[11px] text-[#F4EBE6]/50 hover:text-[#E893AE] transition-colors font-light"
            >
              Privacy
            </Link>
            <Link
              data-testid="footer-link-terms"
              to="/terms"
              className="text-[11px] text-[#F4EBE6]/50 hover:text-[#E893AE] transition-colors font-light"
            >
              Terms
            </Link>
            <Link
              data-testid="footer-link-disclaimer"
              to="/disclaimer"
              className="text-[11px] text-[#F4EBE6]/50 hover:text-[#E893AE] transition-colors font-light"
            >
              Disclaimer
            </Link>
          </div>
        </div>
      </div>

      <p className="mt-12 text-[11px] text-[#F4EBE6]/40 font-light leading-relaxed max-w-3xl">
        Skinfill Bacio is intended for use by qualified aesthetic professionals. Professional product information on
        this website is intended for aesthetic professionals in Australia and New Zealand. Individual results may
        vary. Content on this site is for general information and does not replace professional consultation.
      </p>
      <p className="mt-6 text-[11px] text-[#F4EBE6]/40 font-light">
        © {new Date().getFullYear()} SKINFILL BACIO® — Australia &amp; New Zealand. Distributed by Dermalis. All rights
        reserved.
      </p>
    </div>
  </footer>
);

export default Footer;
